import cryptoJs from 'crypto-js';
import api from '../services/api';
import { loginAccount, registerAccount } from '../utils/login-redirected';

export const googleLogin = () => {
  /**
   * It decodes the answer from google
   * @param {String} data : It is the string data from google response
   * @returns {Object} : It is the decoded object
   */
  const decodeJwtResponse = (data) => {
    const tokens = data.split('.');
    return JSON.parse(atob(tokens[1]));
  };

  /**
   * It hashes the google token
   * @param {String} string : It is a token from google
   * @param {String} secret : It is a token from google
   * @returns {String} string : It is the hashed token to use as password
   */
  const hashToken = (string, secret) => {
    const encrypted = cryptoJs.SHA256(`${string}${secret}`).toString();
    const result = encrypted.match(/.{1,39}/g) ?? [];
    return result[0];
  };

  /**
   * It handles the google response
   * @param {Object} response : It is the google response
   */
  const handleCredentialResponse = async (response) => {
    try {

      const responsePayload = decodeJwtResponse(response.credential);
      /**
       * Aud and sub are permanent values from google
       * response to be used as string and secret
       */
      const {
        aud,
        sub,
        email,
        family_name: familyName,
        given_name: givenName,
      } = responsePayload;

      const hashedToken = hashToken(aud, sub);
      const shopifyUser = await api.verifyAccount(email);

      if (shopifyUser.exists) {
        loginAccount(email, hashedToken);
      } else {
        const params = { email, hashedToken, familyName, givenName };
        registerAccount(params);
      }
    } catch (error) {
      console.error(`There was an error: ${error.message}`);
    }
  };

  window.addEventListener('load', () => {
    if (!window.google) return;

    google.accounts.id.initialize({
      client_id:
        '391331130491-va318f302d1isi29ahv7cq720o0q0efb.apps.googleusercontent.com',
      callback: handleCredentialResponse,
    });
    google.accounts.id.renderButton(
      document.getElementById('g-button'),
      {
        type: 'icon',
        theme: 'outline',
        size: 'large',
        shape: 'circle',
        width: '300px',
      }
    );
 });
};
